
import { Link } from 'react-router-dom';
import '../../App.css'; // Import your CSS file
import SignUpForm from '../signupPage/signupPage';
import 'bootstrap/dist/css/bootstrap.min.css';


function SignupUser({ setShowSpinner }) {

  return (
    <div className='main-container'>
      <div className='content'>
        <div>
          <h1 className='heading' >Research <span>Mate</span></h1>
          {/* <p className='title'>Enjoy Your Clinical Trial With <span>Research Mate</span></p> */}
          <img className='characterImg' alt='characterImg' src={require('../../images/kerlocopy.png')} ></img>
          <div className="tooltip-container">
            <span className="tooltip-1">Post Study as a Sponsor.</span>
            <Link className='login-link' to={'/whyResearchMate'}>Post Study as a Sponsor</Link>
          </div>
        </div>
        <div className='formPage'>
          <SignUpForm setShowSpinner={setShowSpinner} />
        </div>
      </div>
    </div>
  );
}

export default SignupUser;
